const defaultState = {}

const slides = (state = defaultState, action) => {
  switch (action.type) {
    case 'SLIDES_ADD':
      return {
        ...state,
        ...action.data
      }
    default:
      return state
  }
}

export default slides



// WEBPACK FOOTER //
// ./src/reducers/slides.js